//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export type UniversalImageActionsViewName =
  | 'Details'
  | 'Home'
  | 'ApproveForFanreel'
  | 'ApproveForGalleries'
  | 'Productize'
  | 'ScheduleNow'
  | 'OnePage'
  | 'FanreelTag'
  | 'ScheduleTag'
  | 'Labels'
  | 'RightsRequest'
  | 'Reveal'
  | 'Reveal2'
  | 'Revolve'
  | 'Tributary'
  | 'TributaryCustomizeProducts'
  | 'TributaryCustomizeMedia'
  | 'TributaryAddOns'
  | 'TributaryCustomizeLinks'
  | 'Notes';

export const UniversalImageActionsView = {
  Details: {
    name: 'Details',
    template: '<uia-details></uia-details>',
  },
  Home: {
    name: 'Home',
    template: '',
  },
  ApproveForFanreel: {
    name: 'ApproveForFanreel',
    template:
      '<universal-image-actions-fanreel></universal-image-actions-fanreel>',
  },
  ApproveForGalleries: {
    name: 'ApproveForGalleries',
    template:
      '<div with-unison><universal-image-actions-gallery></universal-image-actions-gallery></div>',
  },
  Productize: {
    name: 'Productize',
    label: 'Add Products',
    template:
      '<universal-image-actions-productize features="model.features"></universal-image-actions-productize>',
    overlay:
      '<universal-image-actions-productize-overlay image-url="model.displayImageUrl"' +
      ' features="model.features"></universal-image-actions-productize-overlay>',
  },
  ScheduleNow: {
    name: 'ScheduleNow',
    template:
      '<universal-image-actions-schedule-now></universal-image-actions-schedule-now>',
  },
  OnePage: {
    name: 'OnePage',
    label: 'ONE Page',
    template:
      '<div with-unison><universal-image-actions-one-page></universal-image-actions-one-page></div>',
  },
  FanreelTag: {
    name: 'FanreelTag',
    label: 'Add Tags',
    template:
      '<universal-image-actions-fanreel-tag></universal-image-actions-fanreel-tag>',
  },
  ScheduleTag: {
    name: 'ScheduleTag',
    label: 'Add Tags',
    template:
      '<universal-image-actions-schedule-tag></universal-image-actions-schedule-tag>',
  },
  Labels: {
    name: 'Labels',
    label: 'Add Labels',
    template: '<uia-labels></uia-labels>',
  },
  RightsRequest: {
    name: 'RightsRequest',
    label: 'Request Rights',
    template:
      '<universal-image-actions-rights-request></universal-image-actions-rights-request>',
  },
  Reveal: {
    name: 'Reveal',
    label: 'Reveal',
    template:
      '<universal-image-actions-reveal></universal-image-actions-reveal>',
  },
  Reveal2: {
    name: 'Reveal2',
    label: 'Reveal',
    template:
      '<universal-image-actions-reveal-v2></universal-image-actions-reveal-v2>',
  },
  Revolve: {
    name: 'Revolve',
    label: 'Revolve',
    template:
      '<universal-image-actions-reveal></universal-image-actions-reveal>',
  },
  Tributary: {
    name: 'Tributary',
    label: 'Next',
    template:
      '<universal-image-actions-tributary></universal-image-actions-tributary>',
  },
  TributaryCustomizeProducts: {
    name: 'TributaryCustomizeProducts',
    label: 'Recommended Products',
    template:
      '<universal-image-actions-tributary-customize-products></universal-image-actions-tributary-customize-products>',
  },
  TributaryCustomizeMedia: {
    name: 'TributaryCustomizeMedia',
    label: 'Related Media',
    template:
      '<universal-image-actions-tributary-customize-media></universal-image-actions-tributary-customize-media>',
  },
  TributaryAddOns: {
    name: 'TributaryAddOns',
    label: 'Add Ons',
    template:
      '<universal-image-actions-tributary-add-ons></universal-image-actions-tributary-add-ons>',
  },
  TributaryCustomizeLinks: {
    name: 'TributaryCustomizeLinks',
    label: 'Showroom Links',
    template:
      '<universal-image-actions-tributary-customize-links></universal-image-actions-tributary-customize-links>',
  },
  Notes: {
    name: 'Notes',
    label: 'Notes',
    template: '<universal-image-actions-notes></universal-image-actions-notes>',
  },
} as const;
